<template>
  <div class="content-wrapper">
        <section class="content-header">
        <div class="container-fluid">
            <div class="row mb-2">
            <div class="col-sm-6">
                <h1> {{title}} Topup</h1>
            </div>
            <div class="col-sm-6">
                <ol class="breadcrumb float-sm-right">
                <li class="breadcrumb-item">
                    <router-link :to="{name: 'dashboard'}">Home</router-link>
                </li>
                <li class="breadcrumb-item active">{{title}} Topup</li>
                </ol>
            </div>
            </div>
        </div>
        </section>

        <!-- Main content -->
        <section class="content" v-if="has_permission === true">
        <div class="container-fluid">
                    <div class="card col-md-12">

                        <form @submit.prevent="saveOrUpdate" method="POST" novalidate>



                              <div class="card-header">
                                  <span >Topup Info</span>
                              </div>

                              <div class="card-body">

                                  <div class="row">
                                      <div class="col-md-6">

                                          <div class="form-group required">
                                              <label class="control-label" for="mobile_no">Mobile No</label>
                                              <div class="input-group">
                                                <span class="input-group-addon input-group-btn">
                                                       <i class="fas fa-pencil-alt"></i>
                                                </span>
                                                <input type="hidden"
                                                        name="operator_code"
                                                        id="operator_code"
                                                        v-model="stateData.operator_code"
                                                />

                                                <input type="hidden"
                                                       name="product_id"
                                                       id="product_id"
                                                       v-model="stateData.product_id"
                                                />

                                                <input :class="{ 'has-error': errors.has('mobile_no') }"
                                                        type="text"
                                                        class="form-control"
                                                        name="mobile_no"
                                                        id="mobile_no"
                                                        placeholder="Mobile No"
                                                        v-model="stateData.mobile_no"  />
                                              </div>
                                              <div class="help text-danger"
                                                    v-show="errors.has('mobile_no')"
                                               >
                                                  {{ errors.first("mobile_no") }}
                                               </div>
                                          </div>

                                         <div class="form-group required">
                                              <label class="control-label" for="amount">Amount</label>
                                              <div style="width: 100%;" class="input-group input-group">
                                                <!-- <button type="button" @click.stop="stateData.amount = stateData.amount != null ? Math.max(stateData.amount - 1, 0) : 0 " class="btn btn-primary input-group-btn" id="btn-minus">-</button> -->
                                                <input type="number" min="10" class="form-control" name="amount" id="amount" v-model.number="stateData.amount" />
                                                <!-- <button type="button" @click.stop="stateData.amount = stateData.amount != null  ? stateData.amount + 1 : 0 " class="btn btn-primary input-group-btn" id="btn-plus">+</button> -->

                                              </div>
                                              <div
                                                  class="help text-danger"
                                                  v-show="errors.has('amount')"
                                               >
                                                  {{ errors.first("amount") }}
                                               </div>
                                          </div>

                                          <div v-if="operator != 'SK'" class="form-group required">
                                              <label class="control-label" for="connection_type">Connection Type</label>
                                              <multiselect
                                                v-model="stateData.connection_type"
                                                :options="[ 'Prepaid', 'Postpaid' ]"
                                                placeholder="Select"
                                                :searchable="true"
                                                :multiple="false"
                                                :class="{ 'has-error': errors.has('connection_type') }"
                                                id="connection_type"
                                                v-validate="'required'"
                                                name="connection_type"
                                                >
                                                </multiselect>
                                                <div
                                                  class="help text-danger"
                                                  v-show="errors.has('connection_type')"
                                                >
                                                  {{ errors.first("connection_type") }}
                                                </div>
                                          </div>

                                          <div class="form-group">
                                            <label class="control-label" for="online">Online ? </label>
                                            <div class="input-group">
                                              <label class="switch">
                                                <input type="checkbox" name="online" id="online"
                                                  v-model.number="stateData.online" >
                                                <span class="slider round"></span>
                                              </label>
                                            </div>

                                              <div
                                                  class="help text-danger"
                                                  v-show="errors.has('online')"
                                               >
                                                  {{ errors.first("online") }}
                                               </div>
                                          </div>

                                      </div>
                                  </div>

                              </div>

                              <div class="card-footer row col-md-6 col-sm-6 col-lg-6">
                                    <div class="col-md-6 col-sm-6 col-lg-6 text-left" style="width:50%">
                                      <a @click="$router.back()" class="btn btn-site">Go Back</a>
                                    </div>

                                    <!-- <a @click="$router.back()" class="btn btn-site text-left">Go Back</a> -->
                                    <!-- <button class="btn btn-site text-right" type="submit">Next</button> -->

                                    <div class="col-md-6 col-sm-6 col-lg-6 text-right" style="width:50%">
                                      <button class="btn btn-site" type="submit">Next</button>
                                    </div>

                              </div>

                        </form>

                        <div class="overlay" v-if="is_loading" >
                                <i class="fas fa-2x fa-sync-alt fa-spin"></i>
                        </div>

                    </div>

        </div>
        </section>

        <section class="content" v-if="has_permission === false">
        <div class="alert alert-danger alert-dismissible">
            <h5><i class="icon fas fa-ban"></i> Permission denied!</h5>
        </div>
        </section>

  </div>
</template>
<style scoped>
span.closed{
   /* background: green; */
   background: #CAFFD6;
   color: #119A30;
}
span.pending{
   background: #FFE9DD;
    /* color: #119A30; */
}
span.open{
  background: #FFE9DD;
}
span.in-progress{
 background: #FFE9DD;
}

div.input-group > button {
  background-color: #8d4097;
}

div.input-group > span {
  border: 1px solid #ccc !important;
}

div.input-group > span > i{
  padding: 10px;
}


/* Swtich Style */

.switch {
  position: relative;
  display: inline-block;
  width: 60px;
  height: 34px;
}

.switch input {
  opacity: 0;
  width: 0;
  height: 0;
}

.slider {
  position: absolute;
  cursor: pointer;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: #ccc;
  -webkit-transition: .4s;
  transition: .4s;
}

.slider:before {
  position: absolute;
  content: "";
  height: 26px;
  width: 26px;
  left: 4px;
  bottom: 4px;
  background-color: white;
  -webkit-transition: .4s;
  transition: .4s;
}

input:checked + .slider {
  background-color: #2196F3;
}

input:focus + .slider {
  box-shadow: 0 0 1px #2196F3;
}

input:checked + .slider:before {
  -webkit-transform: translateX(26px);
  -ms-transform: translateX(26px);
  transform: translateX(26px);
}

/* Rounded sliders */
.slider.round {
  border-radius: 34px;
}

.slider.round:before {
  border-radius: 50%;
}


</style>
<script>

import VuePagination from "@/components/partials/PaginationComponent";
import SortIcons from "@/components/utils/SortIcons";
import axios from 'axios';
import DatePicker from 'vue2-datepicker';
import 'vue2-datepicker/index.css';
import { Notification } from "element-ui";
import {mapMutations} from 'vuex';
import localStorage from '@/services/localStorage';
import { JSEncrypt } from "jsencrypt";
// import * as JSEncrypt from '../../assets/jsencrypt.min.js';

export default {
  name: 'TopupEntry',
  metaInfo: {
    title: 'TopupEntry | Dotlines'
  },

  props: [ 'operator' ],

  components: {
    DatePicker,
    VuePagination,
    SortIcons
  },

  data: () => ({
    privateKey: '',
    publicKey: '',
    pid: null, // primary id of object to edit
    title: '',
    childOperator: '',

    preloadOptions:{
    },

    stateData: {
      operator_code: '',
      product_id: '',
      connection_type: '',
      mobile_no: '',
      amount: 0,
    },

    order_by: 'asc',
    api_url: '',
    showFilter: false,
    filter: {},
    dateRange: '',
    pre: [],
    is_loading: false,
    has_permission: true,
  }),
  // method is called after page load
  mounted: function () {
        this.privateKey =  process.env.VUE_APP_API_PRIVATE_KEY;
        this.publicKey =  process.env.VUE_APP_API_PUBLIC_KEY;
        console.log("Private key::", process.env.VUE_APP_API_PRIVATE_KEY);
        console.log("Public key::", process.env.VUE_APP_API_PUBLIC_KEY);

        // if (this.isMobile()) {
    //   window.$(document).find('.push-menu-class').trigger('click');
    // }

    var stateObject = localStorage.get('stateData')
    console.log("local storage stateData:", stateObject)
    if( stateObject != null ){
      this.childOperator = stateObject.operator
      this.stateData = stateObject.topup
    }else{
      console.log("Not Found in localStore")
      this.childOperator = this.operator
    }

    console.log("Operator:", this.operator);
    if(this.childOperator == 'GP'){
      this.title = 'Grameenphone';
    }else if( this.operator == 'BL' ){
      this.title = 'Banglalink';
    }else if( this.childOperator == 'ROBI' ){
      this.title = 'Robi';
    }else if( this.childOperator == 'AT' ){
      this.title = 'Airtel';
    }else if( this.childOperator == 'TL' ){
      this.title = 'Teletalk';
    }else if( this.childOperator == 'SK' ){
      this.title = 'Skitto';
    }else{
      this.$router.go(-1)
    }

  },


  mutations: {

    changeTopup (state, topup){
        state.topup = topup
    },

  },

  methods: {
    ...mapMutations(['changeTopup']),

    saveOrUpdate(){



        let crypt = new JSEncrypt({default_key_size: 2048});
        // let crypt = new JSEncrypt();
        // var PublicPrivateKey = {
        //       publicKey: crypt.getPublicKey(),
        //       privateKey: crypt.getPrivateKey()
        // };
        crypt.setPublicKey(this.publicKey);
        crypt.setPrivateKey(this.privateKey);
        // console.log("Encrypt::", PublicPrivateKey);
        var _this = this;
        let jsonPayloadString = JSON.stringify(_this.stateData);
        console.log("Json payload::", jsonPayloadString);
        let hashValuePayload = _this.$CryptoJS.SHA256(jsonPayloadString); // return wordArray
        console.log("WordArray::", hashValuePayload);
        let base64String = hashValuePayload.toString(_this.$CryptoJS.enc.Base64);
        console.log("Hashvalue::", base64String);
        let encryptedHashValue = crypt.encrypt(base64String);
        console.log("Encrypted Hashvalue::", encryptedHashValue);
        _this.stateData.publicKey = _this.publicKey;
        // return;
        let id = this.$route.params.id;
        //this.$store.dispatch("changeTopup", this.stateData)
        _this.$validator.validateAll().then((result) => {
           // _this.stateData.status = 1;
            if(result){
                let api_url;
                _this.is_loading = true;
                api_url = "/save_topup";
                axios({
                method: "POST",
                url: api_url,
                data: _this.stateData,
                headers: { "Content-Type": "application/json", "X-Payload-Signature": encryptedHashValue  },
                })
                .then(function (response) {
                        _this.$toaster.success(response.data.message);
                        _this.is_loading = false;
                        //Object.keys(_this.stateData).forEach(key => {_this.stateData[key]=null}); // clear object property values

                        var storeData = {
                          operator: _this.childOperator,
                          topup: response.data.data
                        }
                        localStorage.set('stateData', storeData)
                        // _this.$router.push({ name: "topup_payment_confirm", params: { 'operator': _this.childOperator, 'topup': response.data.data } });
                })
                .catch((errors) => {
                        //alert("Error happend!");
                        console.log("Error:", errors);
                         _this.is_loading = false;
                        //  _this.$setErrorsFromResponse(errors.response.data);
                        //_this.$setErrorsFromResponse(errors.response.data.errors);
                })
                .finally(() => {
                      _this.is_loading = false;
                });
            }else{
                console.log("Validation failed");
            }
        });
    },


    apiUsage(query = null) {

    },

  }
}
</script>

</script>
